export const cartsData = 'carts';
export const wishsData = 'wish';
export const genUserId = 'genUserId';
export const userData = 'userData';
export const currencyData = 'currency';
export const languageData = 'language';
export const timeStamp = 'timeStamp';
export const response = 'response';
export const appToken = 'appToken';
export const appTheme = 'appTheme';
export const firebaseToken = 'firebaseToken';
export const isGuestUser = 'isGuestUser';

export const categoryImages =
    [
        'c-1.png',
        'fashion.png',
        'fashion.png',
        'tshirt.png',
        'sneakers.png',
        'television.png',
        'accessories.png'
    ];

export const bannerImages = [
    'banner-24.png',
    'banner-25.png',
    'banner-26.png',
];

export const productImages = [
    '15.png',
    '16.png',
    '17.png',
    '18.png',
    '19.png',
    '20.png',
    '21.png',
    '22.png',
];

export const productDetailImages = [
    '4.jpg',
    '6-a.jpg',
    '7.jpg',
    '7-a.jpg'
]

export const themes = [
    { id: 1, name: 'Default Theme', className: 'theme-default' },
    { id: 2, name: 'Clothing Theme 1', className: 'theme-clothing-1' },
    { id: 3, name: 'Clothing Theme 2', className: 'theme-clothing-2' },
    { id: 4, name: 'Clothing Theme 3', className: 'theme-clothing-3' },
    { id: 5, name: 'Restaurant Theme 1', className: 'theme-restaurant-1' },
    { id: 6, name: 'Restaurant Theme 2', className: 'theme-restaurant-2' },
    { id: 7, name: 'Restaurant Theme 3', className: 'theme-restaurant-3' },
];
